import { useEffect } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import { Grid, xcss } from "@atlaskit/primitives";

import { useSearchParameters } from "@/components/signup/hooks";

import { JiraOverlay } from "./jira-overlay";
import LeftHandSide from "./left-hand-side";
import RightHandSide from "./right-hand-side";
import { getTeamTypeWithFlow } from "./utils";

const WorkOnFirstView = () => {
    const { teamType } = useSearchParameters();
    const teamTypeValue = getTeamTypeWithFlow(teamType);
    const { createAnalyticsEvent } = useAnalyticsEvents();

    useEffect(() => {
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "workOnFirstScreen",
            attributes: {
                teamType: teamTypeValue
            }
        }).fire();
    }, []);

    return (
        <JiraOverlay>
            <Grid autoFlow="column" gap="space.0" xcss={gridStyles}>
                <LeftHandSide teamType={teamTypeValue} />
                <RightHandSide teamType={teamTypeValue} />
            </Grid>
        </JiraOverlay>
    );
};

const gridStyles = xcss({
    width: "100%",
    height: "100%",
    gridTemplateColumns: "50% 50%"
});

export default WorkOnFirstView;
